import { render, staticRenderFns } from "./Projeto.vue?vue&type=template&id=9258cbe2&scoped=true&"
import script from "./Projeto.vue?vue&type=script&lang=js&"
export * from "./Projeto.vue?vue&type=script&lang=js&"
import style0 from "./Projeto.vue?vue&type=style&index=0&id=9258cbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9258cbe2",
  null
  
)

export default component.exports